/**
 * FirmwareVersion Module
 */
import Vue from "vue";
import Vuex from "vuex";
import api from "Api";
import router from "Router";
import app from "Main";
import { getFirmwareVersions } from "./api.firmware_versions";

const state = {
    page: {},
    firmware_version: null,
    firmware_versions: [],
    firmware_version_options: [],
    firmware_versions_filter: {
        search: "",
        page_size: 0,
        page_num: 1,
    },
};

// getters
const getters = {};

// actions
const actions = {
    async fetchFirmwareVersion({ rootState, commit }, payload) {
        try {
            let body = "";

            if (payload.body) {
                switch (payload.method) {
                    case "post":
                    case "put":
                    case "patch":
                        body = JSON.stringify(payload.body);
                        break;
                    default:
                        body = payload.body;
                }
            }

            let response;

            switch (payload.method) {
                case "post":
                    response = await api.post(payload.url, body);

                    break;
                case "put":
                    response = await api.put(payload.url, body);

                    break;
                case "patch":
                    response = await api.patch(payload.url, body);

                    break;
                case "delete":
                    response = await api.delete(payload.url, {
                        params: body,
                    });

                    break;
                case "get":
                default:
                    response = await api.get(payload.url, {
                        params: body,
                    });
            }

            if (typeof response !== "undefined") {
                if (response.data && response.data.page) {
                    commit("commitFirmwareVersion", {
                        property: "page",
                        with: response.data.page,
                    });
                }

                let split_state = payload.stateProperty ? (payload.stateProperty || "").split("|") || [] : [];
                let split_data = payload.dataProperty ? (payload.dataProperty || "").split("|") || [] : [];
                split_state.forEach((ss, i) => {
                    let sd = split_data[i] || ss;
                    if (payload.commit) {
                        commit("commitFirmwareVersion", {
                            property: ss,
                            with: _.get(response.data, sd),
                        });
                        if (payload.localStorage) {
                            localStorage.setItem(ss, JSON.stringify(_.get(response.data, sd)));
                        }
                    }
                    if (payload.mutate) {
                        commit("mutateFirmwareVersion", {
                            property: ss,
                            with: _.get(response.data, sd),
                            method: payload.method,
                            id: payload.id,
                            pk: payload.pk,
                        });
                    }
                });

                return response.data;
            } else {
                return;
            }
        } catch (error) {
            throw error;
        }
    },
    async fetchFirmwareVersions({ rootState, commit, dispatch }, payload = null) {
		try {
			let body = payload.body ? payload.body : "";
			let config = {
				headers: payload.headers ? payload.headers : {},
			};

			const response = await getFirmwareVersions({ body: body, headers: config.headers });

			if (typeof response !== "undefined" && response.data) {
				if (response.data.page) {
					commit("mutate", {
						property: "page",
						with: response.data.page,
					});
				}

				if (body.options) {
					commit("mutate", {
						property: "firmware_version_options",
						with: response.data.firmware_versions,
					});
				}

				return response.data;
			} else {
				console.log("fetch all response error");
				return;
			}
		} catch (error) {
			console.log("fetch all error");
			return;
		}
	},
};

// mutations
const mutations = {
    commitFirmwareVersion(state, payload) {
        _.set(state, payload.property, payload.with || null);
    },
    mutateFirmwareVersion(state, payload) {
        if (payload.method == "post" && payload.with) {
            if (state[payload.property] == null) state[payload.property] = [];
            state[payload.property].push(payload.with);
        } else if (payload.method == "patch" && payload.property && payload.with && payload.pk) {
            let curr_item = state[payload.property][state[payload.property].findIndex((obj) => obj[payload.pk] == payload.with[payload.pk])];
            for (const key in payload.with) if (key in curr_item) curr_item[key] = payload.with[key];
        } else if (payload.method == "delete" && payload.property && payload.pk && payload.id) {
            state[payload.property].splice(
                state[payload.property].findIndex((obj) => obj[payload.pk] == payload.id),
                1
            );
        }
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
